<template>
  <ul :class="simpleWrapClasses" :style="styles" v-if="simple">
    <li
      :title="('上一页')"
      :class="prevClasses"
      @click="prev">
      <a><i class="ivu-icon ivu-icon-ios-arrow-left"></i></a>
    </li>
    <div :class="simplePagerClasses" :title="currentPage + '/' + allPages">
      <input
        type="text"
        :value="currentPage"
        @keydown="keyDown"
        @keyup="keyUp"
        @change="keyUp">
      <span>/</span>
      {{ allPages }}

    </div>
    <li
      :title="('下一页')"
      :class="nextClasses"
      @click="next">
      <a><i class="ivu-icon ivu-icon-ios-arrow-right"></i></a>
    </li>
  </ul>
  <ul :class="wrapClasses" :style="styles" v-else>
        <!--<span :class="[prefixCls + '-total']" v-if="showTotal">-->
            <!--<slot>{{ ('共') }} {{ total }} <template v-if="total <= 1">{{ ('条') }}</template><template-->
              <!--v-else>{{ ('条') }}</template></slot>-->
        <!--</span>-->
    <li
      :title="('上一页')"
      :class="prevClasses"
      @click="prev">
      <a><i class="ivu-icon ivu-icon-ios-arrow-left"></i></a>
    </li>
    <li title="1" :class="firstPageClasses" @click="changePage(1)"><a>1</a></li>
    <li :title="('i.page.prev5')" v-if="currentPage - 3 > 1" :class="[prefixCls + '-item-jump-prev']"
        @click="fastPrev"><a><i class="ivu-icon ivu-icon-ios-arrow-left"></i></a></li>
    <li :title="currentPage - 2" v-if="currentPage - 2 > 1" :class="[prefixCls + '-item']"
        @click="changePage(currentPage - 2)"><a>{{ currentPage - 2 }}</a></li>
    <li :title="currentPage - 1" v-if="currentPage - 1 > 1" :class="[prefixCls + '-item']"
        @click="changePage(currentPage - 1)"><a>{{ currentPage - 1 }}</a></li>
    <li :title="currentPage" v-if="currentPage != 1 && currentPage != allPages"
        :class="[prefixCls + '-item',prefixCls + '-item-active']"><a>{{ currentPage }}</a></li>
    <li :title="currentPage + 1" v-if="currentPage + 1 < allPages" :class="[prefixCls + '-item']"
        @click="changePage(currentPage + 1)"><a>{{ currentPage + 1 }}</a></li>
    <li :title="currentPage + 2" v-if="currentPage + 2 < allPages" :class="[prefixCls + '-item']"
        @click="changePage(currentPage + 2)"><a>{{ currentPage + 2 }}</a></li>
    <li :title="('i.page.next5')" v-if="currentPage + 3 < allPages" :class="[prefixCls + '-item-jump-next']"
        @click="fastNext"><a><i class="ivu-icon ivu-icon-ios-arrow-right"></i></a></li>
    <li :title="allPages" v-if="allPages > 1" :class="lastPageClasses" @click="changePage(allPages)"><a>{{ allPages
      }}</a></li>
    <li
      :title="('下一页')"
      :class="nextClasses"
      @click="next">
      <a><i class="ivu-icon ivu-icon-ios-arrow-right"></i></a>
    </li>
    <span :class="[prefixCls + '-total']" v-if="showTotal">
            <slot>{{ ('共') }} {{ total }} <template v-if="total <= 1">{{ ('条') }}</template><template
              v-else>{{ ('条') }}</template></slot>
    </span>
    <slot name="totalpsn"></slot>
    <Options
      :show-sizer="showSizer"
      :page-size="currentPageSize"
      :page-size-opts="pageSizeOpts"
      :placement="placement"
      :show-elevator="showElevator"
      :_current.once="currentPage"
      :current="currentPage"
      :all-pages="allPages"
      :is-small="isSmall"
      @on-size="onSize"
      @on-page="onPage">
    </Options>
  </ul>
</template>
<script>
  import Options from './options.vue'
  const prefixCls = 'ivu-page'
  const oneOf = (value, validList) => {
    for (let i = 0; i < validList.length; i++) {
      if (value === validList[i]) {
        return true
      }
    }
    return false
  }
  export default {
    name: 'sn-page',
    components: {Options},
    props: {
      current: {
        type: Number,
        default: 1
      },
      total: {
        type: Number,
        default: 0
      },
      pageSize: {
        type: Number,
        default: 10
      },
      pageSizeOpts: {
        type: Array,
        default () {
          return [10, 20, 30, 40]
        }
      },
      placement: {
        validator (value) {
          return oneOf(value, ['top', 'bottom'])
        },
        default: 'bottom'
      },
      size: {
        validator (value) {
          return oneOf(value, ['small'])
        }
      },
      simple: {
        type: Boolean,
        default: false
      },
      showTotal: {
        type: Boolean,
        default: false
      },
      showElevator: {
        type: Boolean,
        default: false
      },
      showSizer: {
        type: Boolean,
        default: false
      },
      className: {
        type: String
      },
      styles: {
        type: Object
      }
    },
    data () {
      return {
        prefixCls: prefixCls,
        currentPage: this.current,
        currentPageSize: this.pageSize
      }
    },
    watch: {
      total (val) {
        let maxPage = Math.ceil(val / this.currentPageSize)
        if (maxPage < this.currentPage && maxPage > 0) {
          this.currentPage = maxPage
        }
      },
      current (val) {
        this.currentPage = val
      },
      pageSize (val) {
        this.currentPageSize = val
      }
    },
    computed: {
      isSmall () {
        return !!this.size
      },
      allPages () {
        const allPage = Math.ceil(this.total / this.currentPageSize)
        return (allPage === 0) ? 1 : allPage
      },
      simpleWrapClasses () {
        return [
          `${prefixCls}`,
          `${prefixCls}-simple`,
          {
            [`${this.className}`]: !!this.className
          }
        ]
      },
      simplePagerClasses () {
        return `${prefixCls}-simple-pager`
      },
      wrapClasses () {
        return [
          `${prefixCls}`,
          {
            [`${this.className}`]: !!this.className,
            'mini': !!this.size
          }
        ]
      },
      prevClasses () {
        return [
          `${prefixCls}-prev`,
          {
            [`${prefixCls}-disabled`]: this.currentPage === 1
          }
        ]
      },
      nextClasses () {
        return [
          `${prefixCls}-next`,
          {
            [`${prefixCls}-disabled`]: this.currentPage === this.allPages
          }
        ]
      },
      firstPageClasses () {
        return [
          `${prefixCls}-item`,
          {
            [`${prefixCls}-item-active`]: this.currentPage === 1
          }
        ]
      },
      lastPageClasses () {
        return [
          `${prefixCls}-item`,
          {
            [`${prefixCls}-item-active`]: this.currentPage === this.allPages
          }
        ]
      }
    },
    methods: {
      changePage (page) {
        if (this.currentPage !== page) {
          this.currentPage = page
          this.$emit('update:current', page)
          this.$emit('on-change', page)
        }
      },
      prev () {
        const current = this.currentPage
        if (current <= 1) {
          return false
        }
        this.changePage(current - 1)
      },
      next () {
        const current = this.currentPage
        if (current >= this.allPages) {
          return false
        }
        this.changePage(current + 1)
      },
      fastPrev () {
        const page = this.currentPage - 5
        if (page > 0) {
          this.changePage(page)
        } else {
          this.changePage(1)
        }
      },
      fastNext () {
        const page = this.currentPage + 5
        if (page > this.allPages) {
          this.changePage(this.allPages)
        } else {
          this.changePage(page)
        }
      },
      onSize (pageSize) {
        this.currentPageSize = pageSize
        this.$emit('on-page-size-change', pageSize)
        this.changePage(1)
      },
      onPage (page) {
        this.changePage(page)
      },
      keyDown (e) {
        const key = e.keyCode
        const condition = (key >= 48 && key <= 57) || (key >= 96 && key <= 105) || key === 8 || key === 37 || key === 39

        if (!condition) {
          e.preventDefault()
        }
      },
      keyUp (e) {
        const key = e.keyCode
        const val = parseInt(e.target.value)
        if (key === 38) {
          this.prev()
        } else if (key === 40) {
          this.next()
        } else if (key === 13) {
          let page = 1
          if (isNaN(val)) {
            page = 1
          } else if (val > this.allPages) {
            page = this.allPages
          } else if (val <= 0) {
            page = 1
          } else {
            page = val
          }
          e.target.value = page
          this.changePage(page)
        }
      }
    }
  }
</script>
<style lang="less">
  @import './custom';
  @import './input';
  @css-prefix: 'ivu-';
  @page-prefix-cls: ~"@{css-prefix}page";
  .placeholder(@color: @input-placeholder-color) {
    // Firefox
    &::-moz-placeholder {
      color: @color;
      opacity: 1; // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526
    }
    // Internet Explorer 10+
    &:-ms-input-placeholder {
      color: @color;
    }
    // Safari and Chrome
    &::-webkit-input-placeholder {
      color: @color;
    }
  }

  // for select and input like component's arrow
  .inner-arrow() {
    position: absolute;
    top: 50%;
    right: 8px;
    line-height: 1;
    margin-top: -7px;
    font-size: @font-size-base;
    color: @subsidiary-color;
    transition: all @transition-time @ease-in-out;
  }
  .@{page-prefix-cls} {
    &:after {
      content: '';
      display: block;
      height: 0;
      clear: both;
      overflow: hidden;
      visibility: hidden;
    }

    &-item {
      display: inline-block;
      //float: left;
      vertical-align: middle;
      min-width: @btn-circle-size;
      height: @btn-circle-size;
      line-height: @btn-circle-size - 2px;
      margin-right: 4px;
      text-align: center;
      list-style: none;
      background-color: #fff;
      user-select: none;
      cursor: pointer;
      font-family: Arial;
      border: 1px solid @border-color-base;
      border-radius: @btn-border-radius;
      //transition: all @transition-time @ease-in-out;
      transition: border @transition-time @ease-in-out, color @transition-time @ease-in-out;

      a {
        margin: 0 6px;
        text-decoration: none;
        color: @text-color;
        //transition: none;
      }

      &:hover {
        border-color: @primary-color;
        a {
          color: @primary-color;
        }
      }

      &-active {
        background-color: @primary-color;
        border-color: @primary-color;

        a, &:hover a {
          color: #fff;
        }
      }
    }

    &-item-jump-prev, &-item-jump-next {
      &:after {
        content: "•••";
        display: block;
        letter-spacing: 1px;
        color: #ccc;
        text-align: center;
      }

      i{
        display: none;
      }

      &:hover {
        &:after{
          display: none;
        }
        i{
          display: inline;
        }
      }
    }

    &-item-jump-prev:hover {
      i:after {
        content: "\F3D2";
      }
    }

    &-item-jump-next:hover {
      i:after {
        content: "\F3D3";
      }
    }

    &-prev{
      margin-right: 8px;
    }

    &-item-jump-prev,
    &-item-jump-next{
      margin-right: 4px;
    }

    &-next{
      margin-left: 4px;
    }

    &-prev,
    &-next,
    &-item-jump-prev,
    &-item-jump-next {
      display: inline-block;
      vertical-align: middle;
      //float: left;
      min-width: @btn-circle-size;
      height: @btn-circle-size;
      line-height: @btn-circle-size - 2px;
      list-style: none;
      text-align: center;
      cursor: pointer;
      color: #666;
      font-family: Arial;
      border: 1px solid @border-color-base;
      border-radius: @btn-border-radius;
      transition: all @transition-time @ease-in-out;
    }

    &-prev,
    &-next {
      background-color: #fff;

      a {
        color: #666;
        font-size: 14px;
      }

      &:hover {
        border-color: @primary-color;

        a {
          color: @primary-color;
        }
      }
    }

    &-disabled {
      cursor: @cursor-disabled;
      a {
        color: #ccc;
      }
      &:hover {
        border-color: @border-color-base;
        a {
          color: #ccc;
          cursor: @cursor-disabled;
        }
      }
    }

    &-options {
      display: inline-block;
      vertical-align: middle;
      //float: left;
      margin-left: 15px;
      &-sizer {
        display: inline-block;
        //float: left;
        margin-right: 10px;
      }

      &-elevator {
        display: inline-block;
        vertical-align: middle;
        //float: left;
        height: @btn-circle-size;
        line-height: @btn-circle-size;

        input {
          .input;
          border-radius: @btn-border-radius;
          margin: 0 8px;
          width: 50px;
        }
      }
    }

    &-total {
      display: inline-block;
      //float: left;
      height: @btn-circle-size;
      line-height: @btn-circle-size;
      margin-right: 10px;
    }

    &-simple &-prev,
    &-simple &-next {
      margin: 0;
      border: 0;
      height: 24px;
      line-height: 24px;
      font-size: 18px;
    }

    &-simple &-simple-pager {
      display: inline-block;
      //float: left;
      margin-right: 8px;

      input {
        width: 30px;
        height: 24px;
        margin: 0 8px;
        padding: 5px 8px;
        text-align: center;
        box-sizing: border-box;
        background-color: #fff;
        outline: none;
        border: 1px solid @border-color-base;
        border-radius: @btn-border-radius;
        transition: border-color @transition-time @ease-in-out;

        &:hover {
          border-color: @primary-color;
        }
      }

      span{
        padding: 0 8px 0 2px;
      }
    }
  }

  .@{page-prefix-cls} {
    &.mini &-total {
      height: @btn-circle-size-small;
      line-height: @btn-circle-size-small;
    }

    &.mini &-item {
      border: 0;
      margin: 0;
      min-width: @btn-circle-size-small;
      height: @btn-circle-size-small;
      line-height: @btn-circle-size-small;
      border-radius: @btn-border-radius-small;
    }

    &.mini &-prev,
    &.mini &-next {
      margin: 0;
      min-width: @btn-circle-size-small;
      height: @btn-circle-size-small;
      line-height: @btn-circle-size-small;
      border: 0;

      a {
        i:after {
          height: @btn-circle-size-small;
          line-height: @btn-circle-size-small;
        }
      }
    }

    &.mini &-item-jump-prev,
    &.mini &-item-jump-next {
      height: @btn-circle-size-small;
      line-height: @btn-circle-size-small;
      border: none;
      margin-right: 0;
    }

    &.mini &-options {
      margin-left: 8px;
      &-elevator {
        height: @btn-circle-size-small;
        line-height: @btn-circle-size-small;

        input {
          .input-small;
          width: 44px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// page.vue?23333b58